import { useEffect, useState } from 'react';

type Soort = 'info' | 'succes' | 'fout' | 'waarschuwing';
interface T { id: number; tekst: string; soort: Soort }
let luisteraar: ((t: T) => void) | null = null;
let teller = 0;

export function toast(tekst: string, soort: Soort = 'info') {
  luisteraar?.({ id: ++teller, tekst, soort });
}

export function Toasts() {
  const [lijst, setLijst] = useState<T[]>([]);
  useEffect(() => {
    luisteraar = (t) => {
      setLijst((l) => [...l, t]);
      setTimeout(() => setLijst((l) => l.filter((x) => x.id !== t.id)), t.soort === 'fout' ? 7000 : 4000);
    };
    return () => {
      luisteraar = null;
    };
  }, []);
  return (
    <div className="toasts" role="status">
      {lijst.map((t) => (
        <div key={t.id} className={`toast ${t.soort}`} onClick={() => setLijst((l) => l.filter((x) => x.id !== t.id))}>
          {t.tekst}
        </div>
      ))}
    </div>
  );
}
